import type { ReactNode } from 'react';
import { Loader2 } from 'lucide-react';

export function Spinner({ label = 'Loading…' }: { label?: string }) {
  return (
    <div className="row gap-2" style={{ color: 'var(--text-tertiary)', padding: '32px 0', justifyContent: 'center' }}>
      <Loader2 size={18} className="spin" />
      <span className="body-small">{label}</span>
      <style>{`.spin { animation: spin 0.9s linear infinite; } @keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}

export function EmptyState({ icon, title, description, action }: { icon?: ReactNode; title: string; description?: string; action?: ReactNode }) {
  return (
    <div className="stack gap-3" style={{ alignItems: 'center', textAlign: 'center', padding: '56px 24px', color: 'var(--text-tertiary)' }}>
      {icon}
      <div className="h3" style={{ color: 'var(--text)' }}>{title}</div>
      {description && <p className="body-small" style={{ maxWidth: 420 }}>{description}</p>}
      {action}
    </div>
  );
}

export function ErrorBanner({ message }: { message: string }) {
  return (
    <div className="body-small" style={{ background: 'var(--status-critical-bg)', color: 'var(--status-critical)', border: '1px solid rgba(179,38,30,0.25)', borderRadius: 10, padding: '12px 14px' }}>
      {message}
    </div>
  );
}

export function DisclosureBanner({ children }: { children: ReactNode }) {
  return <div className="disclosure-banner">{children}</div>;
}
